import { makeStyles } from '@material-ui/core/styles'
import failure from 'src/assets/Buy_Policy_Images/failure.svg'
import contact from 'src/assets/Buy_Policy_Images/contact.svg'
import { CONTACT, NOTIFICATION_TYPES } from 'src/utils/constants/common'
import React, { useCallback, useEffect, useState } from 'react'
import { scrollToTop } from 'src/utils/commonMethods'
import {
  fetchTokenForBuyPolicy,
  saveISNPStatus,
} from 'src/services/buyPolicyService'
import {
  CURRENT_STATUS,
  ENCOUNTERED_ERROR_WHILE_SAVING,
  INSURANCE_TYPE_CATOGORIES,
} from 'src/utils/constants/BuyPolicy'
import { getISNPStatusRequestBody } from 'src/utils/commonMethods/buyPolicy'
import { showNotificationMessage } from 'src/actions'
import { useDispatch, useSelector } from 'react-redux'
import LoadingModal from 'src/components/common/LoadingModal'
import { NOTIFICATION_MSG_REPORTS } from 'src/utils/constants/CustomerReports'

const KycFailure = () => {
  const classes = useStyles()
  const [loading, setLoading] = useState(false)
  const guestUserDetails = useSelector((state) => state?.buyPolicyReducer)
  const dispatch = useDispatch()

  useEffect(() => {
    scrollToTop()
    saveMetadataAndNavigate()
  }, [saveMetadataAndNavigate])

  const saveMetadataAndNavigate = useCallback(() => {
    setLoading(true)

    fetchTokenForBuyPolicy()
      .then((token) => {
        setLoading(false)
        saveISNPStatusTasks(token)
      })
      .catch(() => {
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.ENCOUNTERED_ERROR_ON_TOKEN_FETCH,
          })
        )
      })
  }, [dispatch, saveISNPStatusTasks])

  const saveISNPStatusTasks = useCallback(
    async (token) => {
      setLoading(true)
      const formData = getISNPStatusRequestBody(
        guestUserDetails,
        INSURANCE_TYPE_CATOGORIES?.health,
        CURRENT_STATUS?.kycFailedPaymentSuccess
      )

      saveISNPStatus(token, formData)
        .then((response) => {
          // This is the response which is coming from backend.
          // The responseData is returned as a promise which is handled in following then block

          return response?.res?.data
        })
        .then(() => {
          // The responseData is returned here and main logic as per requirements will be handled here

          setLoading(false)
        })
        .catch(() => {
          // If there is any error from the backend it will be handled here

          setLoading(false)
          dispatch(
            showNotificationMessage({
              type: NOTIFICATION_TYPES?.ERROR,
              message: ENCOUNTERED_ERROR_WHILE_SAVING,
            })
          )
        })
    },
    [dispatch, guestUserDetails]
  )

  return (
    <div>
      <LoadingModal loading={loading} />
      <div className={classes.mainContainer}>
        <div className={classes.failureContainer}>
          <div className={classes.image}>
            <img src={failure} alt='failure' />
          </div>
          <div className={classes.headingContainer}>
            <div>
              <span className={classes.heading}>
                Something went wrong while validating your KYC
              </span>
            </div>
          </div>
        </div>
        <div className={classes.contactContainer}>
          <div>
            <span className={classes.callInput}>Call Us</span>&nbsp;
          </div>
          <div>
            <img src={contact} alt='' />
            &nbsp;
          </div>
          <div>
            <span className={classes.input}>24/7 Support</span>
            <br></br>
            <span className={classes.number}>{CONTACT?.Contact}</span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default KycFailure
const useStyles = makeStyles({
  failureContainer: {
    background: 'linear-gradient( #EF669B -760%, #FFFFFF 100%)',
    border: 'none',
    width: '60%',
    padding: '30px 80px 30px 80px',
    boxShadow: '0px 6px 8px 0px #4DC3E333',
    borderRadius: '10px',
    position: 'relative',
  },
  mainContainer: {
    padding: '80px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    background: 'white',
  },
  contactContainer: {
    background: 'linear-gradient(0deg, #EBEBEB -33.33%, #FFFFFF 87.68% )',
    borderRadius: '5px',
    border: '1px solid #DCDCDC',
    display: 'flex',
    padding: '5px 18px',
    alignItems: 'center',
    height: '60px',
    marginTop: '-35px',
    zIndex: '1',
  },
  callInput: {
    fontSize: '16px',
    color: '#BBBBBB',
  },
  input: {
    fontSize: '13px',
    color: '#BBBBBB',
  },
  number: {
    fontSize: '18px',
  },
  headingContainer: {
    textAlign: 'center',
    padding: '40px',
  },
  image: {
    textAlign: 'center',
  },
  heading: {
    color: '#FF7761',
    fontSize: '27.5px',
  },
  content: {
    color: '#676767',
    fontSize: '14px',
  },
  screenshotContent: {
    color: '#CBAEAE',
    fontSize: '13px',
    position: 'absolute',
    bottom: '10px',
    left: '10px',
  },
})
